import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import PaymentScheduleSearch from '../../../features/cfi/payment-schedule/components/PaymentScheduleSearch';

export default function PaymentSchedulePage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Payment Schedule')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<PaymentScheduleSearch />
			</div>
		</React.Fragment>
	)
} 
